import React from 'react';
import { ShieldCheck, Headphones, Lock } from 'lucide-react';

const ITEMS = [
  { icon: ShieldCheck, title: '90-day money-back guarantee', body: 'Six times longer than typical SEO platforms. If it is not working for you within 90 days, you get a full refund.' },
  { icon: Headphones, title: 'Real engineers on your account', body: 'A named specialist sets up, monitors and improves your site — so you never have to learn SEO.' },
  { icon: Lock, title: 'Your data stays yours', body: 'Never shared, never resold, never reused. Secure checkout and cancel renewal anytime.' },
];

export default function RankrGuarantee() {
  return (
    <section className="bg-[#0B0B0B] border-t border-white/10 py-16 lg:py-24">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 grid md:grid-cols-3 gap-5">
        {ITEMS.map(({ icon: Icon, title, body }) => (
          <div key={title} className="rounded-2xl border border-white/10 bg-white/[0.03] p-7">
            <div className="w-11 h-11 rounded-lg bg-[#2563EB]/15 flex items-center justify-center">
              <Icon className="w-5 h-5 text-[#3B82F6]" />
            </div>
            <h3 className="mt-5 font-display font-semibold text-white text-lg">{title}</h3>
            <p className="mt-2 text-sm text-white/55 leading-relaxed">{body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}